import {FC, ReactNode, useState} from "react";
import {Event, EventApprover, EventComment} from "../../../../types/domain.ts";
import {Card} from "antd";
import {EventInfoContent} from "../EventInfoContent/EventInfoContent.tsx";
import {EventCommentsContent} from "../EventCommentsContent/EventCommentsContent.tsx";
import styles from './EventInfoCard.module.css';
import {EventBannerContent} from "../EventBannerContent/EventBannerContent.tsx";
import cx from "classnames";

type Props = {
    event: Event;
    eventComments: EventComment[] | undefined;
    editable: boolean;
    onUpdate: VoidFunction;
    approvers?: EventApprover[];
}

type TabOptions = 'info' | 'banner' | 'comments';

export const EventInfoCard: FC<Props> = ({ event, eventComments, editable, onUpdate, approvers }) => {
    const tabContents: Record<TabOptions, ReactNode> = {
        'info': <EventInfoContent event={event} editable={editable} onUpdate={onUpdate} approvers={approvers} />,
        'banner': <EventBannerContent event={event} onUpdate={onUpdate} editable={editable} />,
        'comments': <EventCommentsContent event={event} comments={eventComments || []} approvers={approvers} onUpdate={onUpdate} />
    }

    const [activeTab, setActiveTab] = useState<TabOptions>('info');

    return (
        <Card
            tabList={[
                {
                    label: 'Информация',
                    key: 'info',
                },
                {
                    label: 'Баннер',
                    key: 'banner'
                },
                {
                    label: `Комментарии (${eventComments?.length || 0})`,
                    key: 'comments',
                }
            ]}
            activeTabKey={activeTab}
            onTabChange={(v) => setActiveTab(v as TabOptions)}
            tabProps={{ size: 'middle' }}
            className={styles.card}
            classNames={{ header: styles.cardHeader, body: cx(styles.cardBody, { [styles.cardBodyScrollable]: activeTab === 'info' }) }}
        >
            {tabContents[activeTab]}
        </Card>
    )
}